import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Col } from "reactstrap";
import { CSSTransition } from "react-transition-group";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from './img/logo-web.png';
import logodgo from './img/logo-dgo.png';

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate } = useLocalization();
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    const encodedPassword = encodeURIComponent(password);
    api.userPassLogin(
      {
        username,
        password:encodedPassword,
      },
      parameters
    )
    .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
        <div className="login-airnet-container text-align-center" ref={nodeRef}>
          <div className="login-airnet-header" style={{ marginBottom: '40px' }}>
            <img src={logo} alt="logo" className="logo-airnet rounded mx-auto d-block" />
          </div>
          <div className="login-airnet-body">
            <Form onSubmit={event => onSubmit(event)}>
              <Col sm="12" xs="12" md="12" style={{ padding: '0px', textAlign: 'left' }}>
              <div><p className="detail">{translate("PlaceholderUserName")}</p></div>
                <Input
                  className="input-airnet"
                  disabled={onLogin}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  placeholder={translate("PlaceholderUserName2")}
                  onChange={e => setUsername(e.target.value)}

                />
              </Col>
              <Col sm="12" xs="12" md="12" style={{ padding: '0px', textAlign: 'left' }}>
              <div className="detail"><p>{translate("PlaceholderPassword")}</p></div>
                <Input
                  className="input-airnet"
                  required={true}
                  disabled={onLogin}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  placeholder={translate("PlaceholderPassword")}
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              {!onLogin ?
                <div className="row airnet-btns-row">
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div>
                      <button
                        block={!parameters.failureRedirect}
                        tabIndex={1}
                        className="enter-airnet"
                        type="submit"
                        name="submit"
                        disabled={!props.turnstileSuccess}
                      >
                        {translate("ButtonEnter")}
                      </button>
                      <a
                    href="https://portal.airnet.com.ar/password-reset/"
                    className="forgotPasswordURL"
                  >
                    {translate("ForgotPassword")}
                  </a>
                    </div>
                    <img className="img" src={logodgo} alt="" />
                  </div>
                </div>
                :
                <Progress animated color="danger" value={100} />
              }
              <div className="messages-container">
                <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ open: false })}>
                  {error.message}
                </Alert>
              </div>
            </Form>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </div>
        </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm, { useInsideForm: true });
